module.exports = __webpack_public_path__ + "img/img-thaihilo.893b9df4.png";